import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
  style?: object;
};
function BankMedium({
  size = 16,
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={style}><path fillRule="evenodd" clipRule="evenodd" d="M20.451 21.33H3.55v-1.902H20.45v1.902zM4.71 18.266v-7.395h1.902v7.395H4.711zM11.05 18.266v-7.395h1.9v7.395h-1.9zM17.388 18.266v-7.395h1.901v7.395h-1.901zM3.045 7.952l8.451-5.282h1.008l8.451 5.282-.503 1.757H3.549l-.504-1.757zm3.819-.144h10.272L12 4.598l-5.136 3.21z"  /></Svg>;
}
export default BankMedium;